function designSwitch(design_identifier, url, session_key, category_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/design-switch`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      design_identifier: design_identifier,
      url: url,
      session_key: session_key,
      category_id: category_id,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default designSwitch;
